import React, { useState } from 'react';
import { Row, Container, Table } from 'reactstrap';
import KaAlert from '../Common/KaAlert';
import useDisplayMessage from '../Common/useDisplayMessage';
import { CreateEditSite } from './CreateEditSite';
import SiteDto from '../Common/dtos/RegisteredSiteDto';
import SiteUpsertDto from '../Common/dtos/SiteUpsertDto';
import BusinessAdminTemplate from '../UserAccess/BusinessAdminTemplate';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import BoldButton from '../Common/BoldButton';
import QueryView from '../Common/QueryView';
import useGetAdminSites from '../Requests/useGetAdminSites';
import { useSelectedBusiness } from '../UserAccess/useSelectedBusiness';

const SitePage = () => {
  const business = useSelectedBusiness();
  const getSites = useGetAdminSites();
  const [showModal, setShowModal] = useState(false);
  const displayMessage = useDisplayMessage();
  const [editingSite, setEditingSite] = useState<SiteDto | null>(null);

  const createEditSuccess = (s: SiteUpsertDto) => {
    displayMessage.success(`Site ${s.name} ${editingSite ? 'updated' : 'created'}`);
    getSites.query();
    setShowModal(false);
  }

  const editClick = (s: SiteDto) => {
    setEditingSite(s);
    setShowModal(true);
  }

  const createClick = () => {
    setEditingSite(null);
    setShowModal(true);
  }

  const unusedSites = business.siteAllowance - (getSites.data?.length ?? 0);

  return <BusinessAdminTemplate>
    <QueryView
      query={getSites}
      renderData={sites =>
        <Container>
          {showModal &&
            <CreateEditSite
              onSuccess={createEditSuccess}
              initialSite={editingSite}
              onHide={() => setShowModal(false)} />
          }
          <Row className="justify-content-between mb-2">
            <div className="col-auto">
              <Row>
                <h2 className="col-auto my-auto ka-blue">Sites</h2>
                <label className="col-auto my-auto" title="unusedSites">({unusedSites} Remaining)</label>
              </Row>
            </div>
            <OverlayTrigger placement="bottom-start"
              overlay={unusedSites <= 0 ?
                <Tooltip>
                  Please contact Kahler Automation to purchase additional sites.
                </Tooltip> : <></>}>
              <div className="col-auto" data-testid="create-site">
                <BoldButton
                  className="btn-ghost-primary"
                  onClick={createClick}
                  disabled={unusedSites <= 0}
                  style={{ pointerEvents: unusedSites <= 0 ? 'none' : 'auto' }}>Create Site</BoldButton>
              </div>
            </OverlayTrigger>
          </Row>
          <KaAlert displayMessage={displayMessage.message} onClose={displayMessage.clear} />
          <Table className="border">
            <thead>
              <tr>
                <th>Name</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {sites.sort((a, b) => a.name.localeCompare(b.name)).map(site =>
                <tr key={site.id}>
                  <td>{site.name}</td>
                  <td align="right"><BoldButton className="btn-ghost-secondary" onClick={() => editClick(site)}>Edit</BoldButton></td>
                </tr>
              )}
            </tbody>
          </Table>
        </Container>
      }
    />
  </BusinessAdminTemplate>
}

export { SitePage };
